import { render, staticRenderFns } from "./resetBtn.vue?vue&type=template&id=0eb8bc34&scoped=true"
import script from "./resetBtn.vue?vue&type=script&lang=js"
export * from "./resetBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb8bc34",
  null
  
)

export default component.exports